import styles from "./YuJaNavbar.module.css";
import { ReactComponent as YuJaLogo } from "../images/yujalogo.svg";
import { ReactComponent as NavbarArrow } from "../images/navbar_arrow_purple.svg";
import { ReactComponent as LogOut } from "../images/LogoutIcon.svg";
import { ReactComponent as Setting } from "../images/SettingNavibarIcon.svg";
import { ReactComponent as Support } from "../images/SupportIcon.svg";
import { ReactComponent as NewWindowIconBlue } from "../images/links/new_window_blue.svg";
import {useHistory, useLocation} from "react-router-dom";
import {useLocalStorageNew} from "../hooks/useLocalStorageNew";
import {useCookie} from "../hooks/useCookie";
import React, {useContext, useEffect, useRef, useState} from "react";
import {
    ACCOUNT_CARD_LOGOUT_TEXT,
    ACCOUNT_CARD_SETTING_TEXT,
    ACCOUNT_CARD_SUPPORT_TEXT,
    BUTTON,
    CREATE_POLL_PATH,
    CSM_ADD_INSTITUTION_PATH, CSM_ADMIN_PATTERNS_PATH,
    CSM_CSM_MANAGEMENT_PATH,
    CSM_HOME_PATH,
    GRADED_POLL,
    HOME_ICON, INTEGRATION_BUTTON,
    LOGIN_PATH,
    MENU_LIST,
    NAVBAR_ENGAGE,
    OPEN_IN_NEW_TAB,
    RESPONSIVE_SIDE_BAR_POINT,
    ROLES,
    YUJA_SUPPORT_LINK
} from "../utils/constants";
import {roleValue2Display} from "../utils/helpers";
import {AuthenticationApiCalls} from "../apis/AuthenticationApiCalls";
import {YuJaTooltip} from "./standardization/YuJaTooltip";
import ResponsiveSidebar from "./ResponsiveSidebar";
import layoutStyles from "../layouts/Layout.module.css";
import NewSidebar from "./NewSidebar";
import useWindowDimensions from "../hooks/useWindowDimensions";
import ProfileIcon from "./ProfileIcon";
import {useSession} from "../hooks/useSession";
import {ReactComponent as INSTITUTIONS} from "../images/bank_gray_icon.svg";
import {ReactComponent as INSTITUTION_ADD} from "../images/bank_plus_gray_icon.svg";
import {ReactComponent as MANAGE_CSM_USERS} from "../images/manage_users.svg";
import {ReactComponent as ADMIN_PATTERN} from "../images/user_settings_icon.svg";
import {ReactComponent as QUICK_SETUP} from "../images/quick_setup_icon.svg";
import {useLoading, YuJaGlobalState} from "../utils/LoadingContext";
import {useConfig} from "../hooks/useConfig";
import {useCSMAccessCheck} from "../hooks/useCSMAccessCheck";
import { Popover } from '@base-ui/react/popover';
import { Separator } from '@base-ui/react/separator';
import {Button} from "@base-ui/react/button";
import SupportModal from "./modals/SupportModal";
import {InstitutionApiCalls} from "../apis/InstitutionApiCalls";

export default function YuJaNavbarNew({ isViewer = false, isCreator = false, countdownContent, webSocketState, pollKeyCode, pollType, pageIdentifier }) {
    const { loading, setLoading } = useLoading();
    const {isQuickSetupModalDismissed, setIsQuickSetupModalDismissed, setSelectedIntegrationBtn} = useContext(YuJaGlobalState);
    let config = useConfig();
    const history = useHistory();
    const location = useLocation();
    const {isCSMAdmin} = useCSMAccessCheck();
    const [, getSession] = useLocalStorageNew("session", {});
    const [, getCookie] = useCookie("name", "Guest");
    const {parseSessionToken, setSession, isFromLMS} = useSession();
    const { logout, switchInst } = AuthenticationApiCalls();
    const {getSupportCode} = InstitutionApiCalls();
    let { width} = useWindowDimensions();
    const isNarrow = width <= RESPONSIVE_SIDE_BAR_POINT;
    const session = getSession();
    const [collapsed, setCollapsed] = useState(true);
    const [showLogoutBtn, setShowLogoutBtn] = useState(!!session.userName);
    const [pinCode, setPinCode] = useState("");
    const [menuItemList, setMenuItemList] = useState([]);
    const popoverRef = useRef(null);
    const [supportModalShown, setSupportModalShown] = useState(false);
    const [accessCode, setAccessCode] = useState("");

    const anonymous = !session.userName;
    let userName;
    if (anonymous) {
        userName = getCookie();
    } else {
        if (session.firstName && session.lastName) {
            userName = session.firstName + " " + session.lastName;
        } else if (session.firstName) {
            userName = session.firstName;
        } else {
            userName = session.userName;
        }
    }
    let email = session.email;
    let role = session.role
    let names = userName.split(" ");

    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }

    const sideNavbarStyle = {
        position: "absolute",
        left: "0px",
        top: "0px",
        minWidth: isNarrow ? "240px" : "60px",
        zIndex: 2,
        overflowX: "hidden",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
        height: "100vh",
    };



    const onClickLogo = () => {
        if (!!session.gradedLink) {
            return;
        }

        if (!!session.userName) {
            history.push("/home");
        } else {
            history.push(LOGIN_PATH);
        }

    }

    const closeProfileMenu = () => {
        if (popoverRef.current) {
            popoverRef.current.close();
        }
    }

    const logoutFunction = () => {
        closeProfileMenu();
        if (window.location.pathname.startsWith(MENU_LIST.CREATE.path) || window.location.pathname.startsWith(MENU_LIST.CREATE.altPath)) {
            history.push({
                pathname: CREATE_POLL_PATH,
                state: {pollType: GRADED_POLL, fromNavbar: true, previous: CREATE_POLL_PATH, logout: true}
            });
        }
        else {
            logout();
        }
    }

    const switchToCSM = (path) => {
        if (loading) {
            return;
        }


        setLoading(true);
        switchInst(config.csm_short_name).then((secret) => {
            if(!!secret) {
                window.location.href =
                    `https://${config.csm_short_name}.${config.host_url}/csm/redirect?secret=${secret}&to=${path}`
            } else {
                setSession({});
                history.push(LOGIN_PATH);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        let payLoad = parseSessionToken();
        if (!!payLoad) {
            const {pinCode=""} = payLoad;
            setPinCode(!!pinCode ? pinCode : "");
        }



        const copy = [];
        if (session.role === ROLES.IT_MANAGER.value) {
            copy.push({
                icon: QUICK_SETUP,
                label: "Quick Setup Guide",
                onClick: () =>{
                    closeProfileMenu();
                    if (!isQuickSetupModalDismissed) {
                        return;
                    }

                    setIsQuickSetupModalDismissed(false);
                    if (location.pathname !== MENU_LIST.INTEGRATIONS.path) {
                        history.push(MENU_LIST.INTEGRATIONS.path);
                    }

                }}
            );
        }


        if (session.isFromCSM) {
            copy.push({icon: INSTITUTIONS, label: "Institutions", onClick: () => switchToCSM(CSM_HOME_PATH)});
            copy.push({icon: INSTITUTION_ADD, label: "Install", onClick: () => switchToCSM(CSM_ADD_INSTITUTION_PATH)});
        }

        if (isCSMAdmin()) {
            copy.push({icon: MANAGE_CSM_USERS, label: "Manage CSM", onClick: () => switchToCSM(CSM_CSM_MANAGEMENT_PATH)});
            copy.push({icon: ADMIN_PATTERN, label: "Admin Patterns", onClick: () => switchToCSM(CSM_ADMIN_PATTERNS_PATH)});
        }

        copy.push({
            icon: Support,
            label: ACCOUNT_CARD_SUPPORT_TEXT,
            onClick: () => {
                // window.open(YUJA_SUPPORT_LINK);
                setSupportModalShown(true);
                closeProfileMenu();
            }
        });

        if (!anonymous && !session.gradedLink) {
            copy.push({
                icon: Setting,
                label: ACCOUNT_CARD_SETTING_TEXT,
                onClick: () => {
                    history.push({
                        pathname: role === ROLES.VIEWER.value ? "/student/settings" : "/admin/platformsetting",
                        state: {User: true}
                    });
                    closeProfileMenu();
                }
            });
        }

        if (!anonymous
            && showLogoutBtn
            && (!isFromLMS() || window.location === window.parent.location)
        ) {
            copy.push({
                icon: LogOut,
                label: ACCOUNT_CARD_LOGOUT_TEXT,
                onClick: () => logoutFunction()
            });
        }
        setMenuItemList(copy);

    }, [isQuickSetupModalDismissed, location]);


    useEffect(() => {
        if (!session.authorization) {
            return;
        }
        getSupportCode().then(code => {
            setAccessCode(code);
        });
    }, []);

    return (
        <div
            id="viewer-navbar-container"
            className={`${styles.navBarContainer} ${isNarrow ? styles.responsiveNavBarContainer : ""}`}
        >
            <SupportModal
                open={supportModalShown}
                setOpen={setSupportModalShown}
                accessCode={accessCode}
            />

            {!isNarrow &&
                <>
                    <div
                        tabIndex={0}
                        role={"link"}
                        aria-label={HOME_ICON}
                        className={`${styles.logoContainer} ${!session.gradedLink ? styles.clickable : ""}`}
                        onClick={onClickLogo}
                    >
                        <YuJaLogo width={24} height={24}/>
                    </div>
                    <div className={styles.pathContainer}>
                        {location.pathname !== MENU_LIST.HOME.path &&
                            <div className={styles.pathContainer}>
                                {NAVBAR_ENGAGE}
                                <NavbarArrow height={15}/>
                                <h1 className={styles.h1BreadCrumb}>
                                    {pageIdentifier}
                                </h1>

                            </div>
                        }

                        {location.pathname === MENU_LIST.HOME.path &&
                            <div className={styles.pathContainer}>
                                <h1 className={styles.h1BreadCrumb}>
                                    {NAVBAR_ENGAGE}
                                </h1>
                            </div>
                        }
                    </div>
                </>
            }

            {!!isNarrow &&
                <ResponsiveSidebar
                    className={`${layoutStyles.LeftSideBarContainer}`}
                    sidebarStyle={sideNavbarStyle}
                    // setShowSideBar={setShowSideBar}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                >
                    <NewSidebar sideBarCollapseAble={false} isViewer={isViewer} isCreator={isCreator} isMobile={true}
                                collapsed={collapsed} setCollapsed={setCollapsed}/>
                </ResponsiveSidebar>
            }
            <div style={{flex: 1, minWidth: 0, height: "100%"}}>
                {countdownContent}
            </div>
            {window.location !== window.parent.location &&
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    {isNarrow &&
                        <YuJaTooltip text={OPEN_IN_NEW_TAB} placement="bottom">
                            <NewWindowIconBlue
                                aria-label={OPEN_IN_NEW_TAB}
                                role={BUTTON}
                                style={{width: 28, height: 28, cursor: "pointer", marginRight: 5}}
                                onMouseDown={e => e.preventDefault()}
                                onClick={() => {
                                    const engageSession = encodeURIComponent(JSON.stringify(getSession()));
                                    const path = window.location.pathname;
                                    const dest = encodeURIComponent(path.includes(CREATE_POLL_PATH) && pollKeyCode ? `/edit/${pollKeyCode}` : path);
                                    const pollTypeParam = encodeURIComponent(pollType ? pollType : "");
                                    window.open(`/portal?engageSession=${engageSession}&dest=${dest}${`&pollType=${pollTypeParam}`}`);
                                }}
                            />
                        </YuJaTooltip>
                    }
                    {!isNarrow &&
                        <YuJaTooltip text={OPEN_IN_NEW_TAB} placement="bottom">
                            <NewWindowIconBlue
                                aria-label={OPEN_IN_NEW_TAB} role={BUTTON}
                                style={{width: 28, height: 28, cursor: "pointer", marginRight: 5}}
                                onMouseDown={e => e.preventDefault()}
                                onClick={() => {
                                    const engageSession = encodeURIComponent(JSON.stringify(getSession()));
                                    const path = window.location.pathname;
                                    const dest = encodeURIComponent(path.includes(CREATE_POLL_PATH) && pollKeyCode ? `/edit/${pollKeyCode}` : path);
                                    const pollTypeParam = encodeURIComponent(pollType ? pollType : "");
                                    window.open(`/portal?engageSession=${engageSession}&dest=${dest}${`&pollType=${pollTypeParam}`}`);
                                }}
                            />
                        </YuJaTooltip>
                    }
                </div>
            }

            <Popover.Root modal={"trap-focus"} actionsRef={popoverRef} style={{display: "flex", alignItems: "center"}}>
                <Popover.Trigger id={"profile-btn"} aria-label={"my profile"} className={styles.profileBtn}>
                    <ProfileIcon
                        size={33}
                        initialLetter={initials[0] ? initials[0] : "G"}
                    />
                    {webSocketState === WebSocket.CONNECTING &&
                        <div style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#b0b0b0",
                            position: "absolute",
                            left: "calc(100% - 10px)",
                            top: "calc(100% - 10px)"
                        }}/>
                    }
                    {webSocketState === WebSocket.OPEN &&
                        <div style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#008400",
                            position: "absolute",
                            left: "calc(100% - 10px)",
                            top: "calc(100% - 10px)"
                        }}/>
                    }
                    {webSocketState === WebSocket.CLOSED &&
                        <div style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#B40030",
                            position: "absolute",
                            left: "calc(100% - 10px)",
                            top: "calc(100% - 10px)"
                        }}/>
                    }
                </Popover.Trigger>
                <Popover.Portal >
                    <Popover.Positioner sideOffset={5} style={{zIndex: 1000}}  align={"end"}>
                        <Popover.Popup >
                            <div className={styles.profileMenuContainer}>
                                <div style={{width: 180, display: "flex", flexDirection: "column", alignItems: "center"}}>
                                    <ProfileIcon
                                        size={45}
                                        initialLetter={initials[0] ? initials[0] : "G"}
                                        style={{margin: 10}}
                                    />
                                    <div
                                        title={userName}
                                        style={{
                                            textAlign: "center", fontWeight: 700, maxWidth: "175px",
                                            fontSize: 20, lineHeight: 1.4, overflow: "hidden", whiteSpace: "nowrap",
                                            textOverflow: "ellipsis", paddingLeft: "10px", paddingRight: "10px"
                                        }}
                                    >{userName} </div>
                                    <div style={{color: "#6F6F6F", fontSize: 14, lineHeight: 1.6,}}>
                                        {roleValue2Display(role)}
                                    </div>
                                    <div
                                        title={email}
                                        style={{
                                            overflow: "hidden", maxWidth: "175px",
                                            textOverflow: "ellipsis", whiteSpace: "nowrap",
                                            fontSize: "14px", lineHeight: 1.6, paddingLeft: "10px", paddingRight: "10px"
                                        }}
                                    > {email} </div>
                                    {!!pinCode &&
                                        <div style={{color: "#6F6F6F", fontSize: "14px", lineHeight: 1.6,}}>
                                            {`PIN: ${pinCode}`}
                                        </div>
                                    }
                                </div>
                                <Separator orientation="horizontal" className={styles.separator}/>
                                <ul
                                    id={"profile-menu"}
                                    aria-label={"user-profile"}
                                    role={"menu"}
                                    className={styles.profileMenu}
                                >
                                    {menuItemList.map((item, index) => {
                                        const {icon, label, onClick} = item;
                                        const Icon = icon;
                                        return (
                                            <li key={index}>
                                                <Button
                                                    className={styles.profileMenuItem}
                                                    autoFocus={index === 0}
                                                    aria-label={label}
                                                    onClick={() => onClick()}
                                                >
                                                    <Icon style={{width: 24, height: 24}} focusable={false}
                                                          role={"presentation"}/>
                                                    <span>{label}</span>
                                                </Button>

                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                        </Popover.Popup>
                    </Popover.Positioner>
                </Popover.Portal>
            </Popover.Root>
        </div>
    );
}